export function liveSessionUrl(sessionId: string, role: "master" | "slave"): string {
  if (role === "slave") return `/live/${sessionId}/slave`;
  const storedMusician = typeof window !== "undefined"
    ? localStorage.getItem(`opuslouange-musician-${sessionId}`)
    : null;
  return storedMusician
    ? `/live/${sessionId}/master?musician=${encodeURIComponent(storedMusician)}`
    : `/live/${sessionId}/master`;
}
